export default class BankConfigFactory {
  static async getBankConfig(bankName: string): Promise<any> {
    let config;
    const bank = bankName.toLowerCase();
    if (bank === "axis") {
      const module = await import(
        "../Controller/Axis/Utils/Config"
      );
      config = module.default;
    } else if (bank === "kotak") {
      const module = await import(
        "../Controller/Kotak/Utils/Config"
      );
      config = module.default;
    } else {
      throw new Error(`Configuration not found for bank: ${bankName}`);
    }
    return config;
  }
}

